import { MapPin, PencilSimple } from "@phosphor-icons/react";
import { UNIT_COLOR, UNIT_SHORT } from "@/lib/gameConfig";

export default function FleetPanel({ stations, apparatusState, dispatches, onStationClick }) {
  return (
    <div className="flex-1 flex flex-col min-w-0 h-full" data-testid="fleet-panel">
      <div className="flex items-center justify-between px-4 py-2 border-b border-white/10 shrink-0">
        <h2 className="mono text-[11px] uppercase tracking-[0.25em] text-zinc-300 font-semibold">
          Fire Stations &amp; Fleet
        </h2>
        <div className="flex items-center gap-4 mono text-[10px] uppercase tracking-widest text-zinc-500">
          <span><span className="text-emerald-400">{stations.length}</span> STATIONS</span>
          <span><span className="text-yellow-400">{dispatches.filter(d => !d.returning).length}</span> ENGAGED</span>
        </div>
      </div>
      <div className="flex-1 overflow-y-auto p-2 grid grid-cols-3 gap-2" data-testid="fleet-grid">
        {stations.length === 0 && (
          <div className="col-span-3 mono text-[11px] text-zinc-500 uppercase tracking-widest text-center py-8">
            — NO STATIONS BUILT — click "Build Station" then click on the map
          </div>
        )}
        {stations.map((s) => {
          const trucks = s.trucks || [];
          const bays = s.bays || trucks.length;
          const available = trucks.filter((t) => apparatusState[t.id]?.available).length;
          const enRoute = dispatches.filter((d) => d.stationId === s.id && !d.returning).length;
          return (
            <button
              key={s.id}
              data-testid={`station-card-${s.id}`}
              onClick={() => onStationClick && onStationClick(s)}
              className="text-left border border-white/10 bg-black/30 p-2.5 flex flex-col hover:bg-black/50 hover:border-emerald-500/40 transition-colors group"
              style={{ borderLeft: "3px solid #30D158" }}
            >
              <div className="flex items-center gap-1.5 mb-1">
                <MapPin size={12} className="text-emerald-400" />
                <span className="text-[12px] font-semibold tracking-tight truncate flex-1">{s.name}</span>
                <PencilSimple size={11} className="text-zinc-600 group-hover:text-emerald-400 transition-colors" />
              </div>
              <div className="mono text-[9px] text-zinc-500 uppercase tracking-widest mb-1.5 truncate">
                BAYS {trucks.length}/{bays}
              </div>
              <div className="flex items-center gap-1 mb-1.5 flex-wrap">
                {trucks.map((t) => {
                  const avail = apparatusState[t.id]?.available;
                  const col = UNIT_COLOR[t.type] || "#888";
                  return (
                    <span
                      key={t.id}
                      className={`mono text-[9px] uppercase tracking-widest px-1 py-0.5 border truncate max-w-[110px] flex items-center gap-1 ${
                        avail ? "text-white" : "text-zinc-500"
                      }`}
                      style={{ borderColor: avail ? col : "rgba(255,255,255,0.08)" }}
                      title={`${t.type} • ${t.name}${avail ? "" : " (en route)"}`}
                    >
                      <span className="w-1 h-1" style={{ background: col }} />
                      {UNIT_SHORT[t.type] || "ENG"} {t.name}
                    </span>
                  );
                })}
              </div>
              <div className="grid grid-cols-3 gap-1.5 mt-auto">
                <Cell label="AVAIL" value={available} color="text-emerald-400" />
                <Cell label="ENGAG" value={enRoute} color="text-yellow-400" />
                <Cell label="TOTAL" value={trucks.length} color="text-white" />
              </div>
            </button>
          );
        })}
      </div>
    </div>
  );
}

function Cell({ label, value, color }) {
  return (
    <div className="border border-white/5 px-1.5 py-1">
      <div className="mono text-[8px] uppercase tracking-widest text-zinc-500">{label}</div>
      <div className={`mono text-sm font-bold ${color}`}>{value}</div>
    </div>
  );
}
